<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap"> {{ getText(coachingConfig?.globalizationConfig, 'title') | uppercase }} </ion-label>
        </ion-item>

        <app-step-description
            *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration"
            [description]="reviewConfig?.twoPlusTwoCoachingIntegration ?
                                getText( reviewConfig?.globalizationConfig, 'instructions' ) : ''"
            [employee]="{
                                imageUrl: getImageUrl(userPreview?.imageUrl),
                                username: userPreview?.username,
                                name: userPreview?.name
                              }"
        ></app-step-description>

        <ion-card mode="ios" class="card-table-data">
            <form *ngIf="(coachingConfig?.questions | questionAttributes: user?.attributes: true).length > 0 && coachingForm; else elseBlock" [formGroup]="coachingForm">
                <h4
                    class="number"
                    *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration 
                                            && !showSkipTwoPlusTwoCoachingEvaluationFlag"
                >
                    I - {{ 'goalsValidation.validateTwoPlusTwoCoaching' | translate }}
                </h4>
                <ng-container *ngIf="!showSkipTwoPlusTwoCoachingEvaluation; else skipAtTpt;">
                    <ion-card-content class="ion-no-padding">
                        <ion-grid class="table-view">
                            <ion-row hidden-mobile class="header"
                                     *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration 
                                        && !showSkipTwoPlusTwoCoachingEvaluation">
                                <ion-col size-md="10">
                                  {{ 'generic.comment' | translate }}
                                </ion-col>
                                <ion-col>
                                    {{ 'generic.validation' | translate }}
                                </ion-col>
                            </ion-row>
                            <ion-row *ngFor="let question of coachingConfig?.questions | questionAttribute : user?.attributes : true : !showSkipTwoPlusTwoCoachingEvaluationFlag;">
                                <ion-col size-xs="12" size-md="10">
                                    <div class="content">
                                        <p class="label-heading" hidden-desktop>{{ 'generic.comment' | translate }}</p>
                                        <h2>{{ getText(question.globalizationConfig, 'title') }}</h2>
                                        <p class="underline-text">{{ coachingForm.get('field' + (question.order)).value }}</p>
                                    </div>
                                </ion-col>
                                <ion-col class="ion-align-self-center" *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration">
                                    <div class="buttons-action">
                                        <ion-button
                                            fill="clear"
                                            mode="ios"
                                            [color]="question.approved === false ? 'danger' : 'gray'"
                                            (click)="canValidate && question.approved = false"
                                        >
                                            <ion-icon class="bp-not-accepted-circle"></ion-icon>
                                        </ion-button>
                                        <ion-button fill="clear" mode="ios"
                                                    [color]="question.approved === true ? 'success' : 'gray'"
                                            (click)="setApprovedAndClearComment(question)">
                                            <ion-icon class="bp-check-circle"></ion-icon>
                                        </ion-button>
                                    </div>
                                </ion-col>
                                <ion-col size="12" *ngIf="question.approved === false">
                                    <ng-container>
                                        <ion-item lines="none" feedback>
                                            <ion-label color="danger" position="stacked"> Feedback </ion-label>
                                            <ion-textarea
                                                [placeholder]="'goalsValidation.rejectionInputPlaceholder' | translate"
                                                [formControlName]="'field' + (question.order) + 'Comment'"
                                            ></ion-textarea>
                                        </ion-item>
                                    </ng-container>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card-content>
                </ng-container>
                <ng-template #skipAtTpt>
                    <app-question-types
                        *ngFor="let question of coachingConfig?.questions | questionAttributes: user?.attributes: true"
                        [question]="question"
                        [formGroup]="coachingForm"
                    ></app-question-types>
                </ng-template>
            </form>

            <ng-container *ngIf="!showSkipTwoPlusTwoCoachingEvaluationFlag && (coachingConfig?.questions | questionAttributes: user?.attributes).length > 0">
                <h4
                    class="number"
                    *ngIf="(coachingConfig?.questions | questionAttributes: user?.attributes: true).length == 0
                    && !showSkipTwoPlusTwoCoachingEvaluationFlag; else elseBlock"
                >
                    II - {{ 'goalsValidation.previousConcept' | translate }}
                </h4>
                <ng-template #elseBlock>
                    <h4 class="number" *ngIf="!showSkipTwoPlusTwoCoachingEvaluationFlag">I - {{ 'goalsValidation.previousConcept' | translate }}</h4>
                </ng-template>
                <ion-grid class="slider" class="ion-align-self-center" size-md="12" *ngFor="let question of coachingConfig?.questions | questionAttributes: user?.attributes">
                    <app-question-types [formGroup]="coachingForm" [question]="question" [hideQuestionTitle]="true"></app-question-types>
                </ion-grid>
            </ng-container>

            <h4
                class="number"
                *ngIf="(coachingConfig?.questions | questionAttributes: user?.attributes: true).length == 0
                        && !showSkipTwoPlusTwoCoachingEvaluationFlag; else elseBlock"
            >
                {{ reviewConfig?.twoPlusTwoCoachingIntegration ? 'III' : 'II' }} - {{ 'generic.comments' | translate }}
            </h4>
            <ng-template #elseBlock>
                <ng-container
                    *ngIf="(!displayedGoals 
                                    || (displayedGoals && displayedGoals.length === 0))
                                    && !showSkipTwoPlusTwoCoachingEvaluationFlag"
                >
                    <h4 class="number">II - {{ 'generic.comments' | translate }}</h4>
                </ng-container>
            </ng-template>
            <ion-textarea *ngIf="!showSkipTwoPlusTwoCoachingEvaluationFlag" fullLined [(ngModel)]="generalComments" [disabled]="!canValidate"></ion-textarea>
            <br /><br />
        </ion-card>
        <br />

        <ion-card
            mode="ios"
            class="card-table-data"
            *ngIf="reviewConfig?.twoPlusTwoCoachingIntegration 
                && !hideGoalsOnGoalsReview 
                && !isUserAttributesInsideConsentGoals"
        >
            <h4
                class="number"
                *ngIf="(coachingConfig?.questions | questionAttributes: user?.attributes: true).length == 0
                && !showSkipTwoPlusTwoCoachingEvaluationFlag; else elseBlock"
            >
                {{ reviewConfig?.twoPlusTwoCoachingIntegration ? 'IV' : 'III' }} - {{ 'goalsValidation.validateGoals' | translate }}
            </h4>
            <ng-template #elseBlock>
                <h4 class="number" *ngIf="!showSkipTwoPlusTwoCoachingEvaluationFlag">
                    {{ reviewConfig?.twoPlusTwoCoachingIntegration && ((!displayedGoals || (displayedGoals && displayedGoals.length === 0)) &&
                    !showSkipTwoPlusTwoCoachingEvaluationFlag) ? 'III' : 'II' }} - {{ 'goalsValidation.validateGoals' | translate }}
                </h4>
            </ng-template>

            <ion-card-header>
                <ion-searchbar
                    mode="ios"
                    class="section-search-custom"
                    [placeholder]="'generic.searchByName' | translate"
                    (keyup)="updateSearch($event.target.value)"
                ></ion-searchbar>

                <ng-container *ngIf="canValidate">
                    <ion-button mode="ios" color="secondary" (click)="openNewGoalModal()"> {{ 'goalsValidation.newGoal' | translate }} </ion-button>
                </ng-container>
            </ion-card-header>

            <ion-card-content class="ion-no-padding">
                <ion-grid class="table-view">
                    <ion-row hidden-mobile class="header">
                        <ion-col *ngIf="inputConfig?.title || inputConfig?.description" [sizeMd]="3"> {{ 'generic.goal' | translate }} </ion-col>
                        <ion-col *ngIf="inputConfig?.weight" [sizeMd]="getColumnSize(inputConfig.questions.length)"> {{ 'generic.weight' | translate }} </ion-col>
                        <ion-col *ngIf="inputConfig?.deadline" [sizeMd]="getColumnSize(inputConfig.questions.length)"> {{ 'generic.deadline' | translate }} </ion-col>
                        <ng-container *ngIf="inputConfig?.questions">
                            <ion-col [sizeMd]="getColumnSize(inputConfig.questions.length)" *ngFor="let question of inputConfig.questions">
                                {{ getText(question.globalizationConfig, 'title') }}
                            </ion-col>
                        </ng-container>
                        <ion-col [sizeMd]="getColumnSize(inputConfig.questions.length)"> {{ 'generic.validation' | translate }} </ion-col>
                    </ion-row>

                    <ion-row *ngFor="let goal of displayedGoals">
                        <!-- Previous Changes -->
                        <ng-container *ngIf="goal.lastVersion">
                            <ion-col *ngIf="inputConfig?.title || inputConfig?.description" size-xs="12" [sizeMd]="3" faded>
                                <div class="content">
                                    <p class="label-heading" hidden-desktop>{{ 'generic.goal' | translate }}</p>
                                    <h2>{{ goal.lastVersion.title }}</h2>
                                    <p class="underline-text">{{ goal.lastVersion.description }}</p>
                                </div>
                            </ion-col>
                            <ion-col *ngIf="inputConfig?.weight" class="ion-align-self-center" faded [sizeMd]="getColumnSize(inputConfig.questions.length)">
                                <p class="label-heading" hidden-desktop>{{ 'generic.weight' | translate }}</p>
                                {{ goal.lastVersion.weight }}%
                            </ion-col>
                            <ion-col *ngIf="inputConfig?.deadline" class="ion-align-self-center" faded [sizeMd]="getColumnSize(inputConfig.questions.length)">
                                <p class="label-heading" hidden-desktop>{{ 'generic.deadline' | translate }}</p>
                                {{ goal.lastVersion.deadline | date : 'dd/MM/yyyy' }}
                            </ion-col>
                            <ng-container *ngIf="inputConfig?.questions">
                                <ion-col
                                    class="ion-align-self-center"
                                    [sizeMd]="getColumnSize(inputConfig.questions.length)"
                                    *ngFor="let question of inputConfig.questions; let index = index"
                                    faded
                                >
                                    <p class="label-heading" hidden-desktop>{{ getText(question.globalizationConfig, 'title') }}</p>
                                    <ng-container
                                        *ngIf="question.typeConfig.type === QuestionType.Date 
                                    || question.typeConfig.type === QuestionType.Deadline"
                                    >
                                        {{ goal.lastVersion['field' + (index + 1)] | translate | date:'dd/MM/yyyy' }}
                                    </ng-container>
                                    <ng-container *ngIf="question.typeConfig.type === QuestionType.Weight">
                                        {{ goal.lastVersion['field' + (index + 1)] | translate }} %
                                    </ng-container>
                                    <ng-container
                                        *ngIf="question.typeConfig.type !== QuestionType.Date 
                                            && question.typeConfig.type !== QuestionType.Weight
                                            && question.typeConfig.type !== QuestionType.Deadline"
                                    >
                                        {{ question.typeConfig?.possibleValuesGlobalized && question.typeConfig?.possibleValuesGlobalized[selectedLanguage]?.length > 0 &&
                                        question.typeConfig?.possibleValues && question.typeConfig?.possibleValues?.length > 0 ?
                                        question.typeConfig?.possibleValuesGlobalized[selectedLanguage][question.typeConfig?.possibleValues.indexOf(goal.lastVersion['field' +
                                        (index + 1)])] : (goal.lastVersion['field' + (index + 1)] | translate) }}
                                    </ng-container>
                                </ion-col>
                            </ng-container>
                            <ion-col class="ion-align-self-center" [sizeMd]="getColumnSize(inputConfig.questions.length)" faded>
                                <p><b>{{ 'generic.beforeEditing' | translate }}</b></p>
                            </ion-col>
                        </ng-container>
                        <!-- Current Changes -->
                        <ion-col *ngIf="inputConfig?.title || inputConfig?.description" size-xs="12" [sizeMd]="3">
                            <div class="content">
                                <p class="label-heading" hidden-desktop>{{ 'generic.goal' | translate }}</p>
                                <h2>{{ goal.title }}</h2>
                                <p class="underline-text">{{ goal.description }}</p>
                            </div>
                        </ion-col>
                        <ion-col *ngIf="inputConfig?.weight" class="ion-align-self-center" [sizeMd]="getColumnSize(inputConfig.questions.length)">
                            <p class="label-heading" hidden-desktop>{{ 'generic.weight' | translate }}</p>
                            {{ goal.weight }}%
                        </ion-col>
                        <ion-col *ngIf="inputConfig?.deadline" class="ion-align-self-center" [sizeMd]="getColumnSize(inputConfig.questions.length)">
                            <p class="label-heading" hidden-desktop>{{ 'generic.deadline' | translate }}</p>
                            {{ goal.deadline | date : 'dd/MM/yyyy' }}
                        </ion-col>
                        <ng-container *ngIf="inputConfig?.questions">
                            <ion-col
                                class="ion-align-self-center"
                                [sizeMd]="getColumnSize(inputConfig.questions.length)"
                                *ngFor="let question of inputConfig.questions; let index = index"
                            >
                                <p class="label-heading" hidden-desktop>{{ getText(question.globalizationConfig, 'title') }}</p>
                                <ng-container
                                    *ngIf="question.typeConfig.type === QuestionType.Date 
                                || question.typeConfig.type === QuestionType.Deadline"
                                >
                                    {{ goal['field' + (index + 1)] | translate | date:'dd/MM/yyyy' }}
                                </ng-container>
                                <ng-container *ngIf="question.typeConfig.type === QuestionType.Weight"> {{ goal['field' + (index + 1)] | translate }} % </ng-container>
                                <ng-container
                                    *ngIf="question.typeConfig.type !== QuestionType.Date 
                                        && question.typeConfig.type !== QuestionType.Weight 
                                        && question.typeConfig.type !== QuestionType.Deadline"
                                >
                                    {{ question.typeConfig?.possibleValuesGlobalized && question.typeConfig?.possibleValuesGlobalized[selectedLanguage]?.length > 0 &&
                                    question.typeConfig?.possibleValues && question.typeConfig?.possibleValues?.length > 0 ?
                                    question.typeConfig?.possibleValuesGlobalized[selectedLanguage][question.typeConfig?.possibleValues.indexOf(goal['field' + (index + 1)])] :
                                    (goal['field' + (index + 1)] | translate) }}
                                </ng-container>
                            </ion-col>
                        </ng-container>
                        <ion-col class="ion-align-self-center" [sizeMd]="getColumnSize(inputConfig.questions.length)">
                            <div class="buttons-action">
                                <ion-button fill="clear" mode="ios" [color]="goal.approved === false ? 'danger' : 'gray'" (click)="canValidate && goal.approved = false">
                                    <ion-icon class="bp-not-accepted-circle"></ion-icon>
                                </ion-button>
                                <ion-button fill="clear" mode="ios" [color]="goal.approved === true ? 'success' : 'gray'" (click)="canValidate && goal.approved = true">
                                    <ion-icon class="bp-check-circle"></ion-icon>
                                </ion-button>

                                <ng-container *ngIf="canValidate">
                                    <ion-button color="danger" fill="clear" mode="ios" (click)="confirmDeleteGoal(goal)">
                                        <ion-icon class="bp-delete" style="font-size: 24px"></ion-icon>
                                    </ion-button>
                                </ng-container>
                            </div>
                        </ion-col>
                        <ion-col size="12" *ngIf="goal.approved === false">
                            <ion-item lines="none" feedback>
                                <ion-label color="danger" position="stacked"> Feedback </ion-label>
                                <ion-textarea [placeholder]="'goalsValidation.rejectionInputPlaceholder' | translate" [(ngModel)]="goal.managerComment"></ion-textarea>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-card-content>
        </ion-card>

        <ng-container *ngIf="canValidate">
            <div class="bottom-buttons ion-text-right">
                <ion-button mode="ios" color="secondary" class="send" (click)="setGoalsFeedbacks(goals)"> {{ 'generic.finish' | translate }} </ion-button>
            </div>
        </ng-container>
    </div>
</ion-content>
